<template>
    <div class="dialog-screen">
        <div class="form-info" style="padding: 0px">
            <div class="form-row">
                <div class="form-label" style="width: 90px">
                    <label class="required">配货标题:</label>
                </div>
                <div class="form-value" style="width:300px;">
                    <el-input v-model="title" placeholder="请输入" title="配货标题"></el-input>
                </div>
                <div class="form-label" style="width: 90px">
                    <label class="required">税率(%):</label>
                </div>
                <div class="form-value" style="width:300px;">
                    <el-input v-model="taxRate" placeholder="请输入" title="税率(%)" @change="taxRateChange(taxRate)"></el-input>
                </div>
                <div class="form-value">
                    <el-checkbox class="ml15" v-model="autoSend">发送</el-checkbox>
                </div>
            </div>
        </div>
        <div class="table-layout">
            <el-table class="thin" :data="pageAllocFormImpList" :height="tableHeight" ref="allocFormImpTable" border style="width: 100%; font-size: 12px" @selection-change="handleSelectionChange" :row-class-name="markSelectedRowClassName">
                <el-table-column type="selection" width="40" align="center" fixed="left"></el-table-column>
                <el-table-column label="源件" width="60" align="center" fixed="left">
                    <el-table-column prop="rowNo" label="行号" width="60" align="center"></el-table-column>
                </el-table-column>
                <el-table-column prop="failed" label="执行状态" width="60" align="center" fixed="left" v-show="startFlag">
                    <template slot-scope="rows">
                        <div v-if="rows.row.failed != null">
                            <span v-if="rows.row.failed" style="color: red;font-size: 20px">×</span>
                            <span v-else style="color: green;font-size: 20px">√</span>
                        </div>
                        <span v-else class="font-gray3">未执行</span>
                    </template>
                </el-table-column>
                <el-table-column prop="failDesc" label="失败描述" width="300" align="left" fixed="left" v-show="startFlag"></el-table-column>
                <el-table-column label="机构名称" prop="buyerShopName" width="200">
                    <template slot-scope="rows">
                        <div v-if="!rows.row.validateInfo.buyerShopName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.buyerShopName.errorMsg">
                            <span>{{rows.row.buyerShopName}}&nbsp;</span>
                        </div>
                        <div v-else>{{rows.row.buyerShopName}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="地址信息" prop="buyerRecvRegionName" width="200">
                    <template slot-scope="rows">
                        <div v-if="!rows.row.validateInfo.buyerRecvRegionName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.buyerRecvRegionName.errorMsg">
                            <span>{{rows.row.buyerRecvRegionName}}&nbsp;</span>
                        </div>
                        <div v-else>{{rows.row.buyerRecvRegionName}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="详细地址" prop="buyerRecvStreet" width="350">
                    <template slot-scope="rows">
                        <div v-if="!rows.row.validateInfo.buyerRecvStreet.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.buyerRecvStreet.errorMsg">
                            <span>{{rows.row.buyerRecvStreet}}</span>
                        </div>
                        <span v-else>{{rows.row.buyerRecvStreet}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="联系人" prop="buyerRecvContractName" width="100">
                    <template slot-scope="rows">
                        <div v-if="!rows.row.validateInfo.buyerRecvContractName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.buyerRecvContractName.errorMsg">
                            <span>{{rows.row.buyerRecvContractName}}</span>
                        </div>
                        <span v-else>{{rows.row.buyerRecvContractName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="联系电话" prop="buyerRecvContactTel" align="center" width="100">
                    <template slot-scope="rows">
                        <div v-if="!rows.row.validateInfo.buyerRecvContactTel.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.buyerRecvContactTel.errorMsg">
                            <span>{{rows.row.buyerRecvContactTel}}</span>
                        </div>
                        <span v-else>{{rows.row.buyerRecvContactTel}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="供应商" prop="sellerName" width="200">
                    <template slot-scope="rows">
                        <div v-if="!rows.row.validateInfo.sellerName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.sellerName.errorMsg">
                            <span>{{rows.row.sellerName}}&nbsp;</span>
                        </div>
                        <div v-else>{{rows.row.sellerName}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="商品名称" prop="title" width="150">
                    <template slot-scope="rows">
                        <div v-if="!rows.row.validateInfo.title.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.title.errorMsg">
                            <span>{{rows.row.title}}&nbsp;</span>
                        </div>
                        <div v-else>{{rows.row.title}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="分类" prop="catName" width="150">
                    <template slot-scope="rows">
                        <div v-if="!rows.row.validateInfo.catName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.catName.errorMsg">
                            <span>{{rows.row.catName}}&nbsp;</span>
                        </div>
                        <div v-else>{{rows.row.catName}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="品牌" prop="brandName" width="150">
                    <template slot-scope="rows">
                        <div v-if="!rows.row.validateInfo.brandName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.brandName.errorMsg">
                            <span>{{rows.row.brandName}}</span>
                        </div>
                        <span v-else>{{rows.row.brandName}}</span>
                    </template>
                </el-table-column>
                <el-table-column width="200" label="关联定义">
                    <template slot-scope="rows">
                        <div class="inline-block" v-if="rows.row.assetDefId != null">已关联</div>
                        <div class="inline-block" v-else>未关联</div>
                        <a class="swb-btn-link fr inline-block" @click="delDevcDef(rows.row)">清除</a>
                        <a class="swb-btn-link fr inline-block" @click="setDevcDef(rows.row)">选择</a>
                        <a class="swb-btn-link fr inline-block" v-if="rows.row.assetDefId == null && (rows.row.asmblAccFlag || (!needAudit && !rows.row.asmblAccFlag))" @click="saveDevcDef(rows.row)">生成定义</a>
                    </template>
                </el-table-column>
                <el-table-column align="left" width="120px" prop="devcName" label="定义全名称"></el-table-column>
                <el-table-column align="center" prop="asmblAccFlag" label="组装件" width="130">
                    <template slot-scope="rows">
                        <input type="checkbox" v-model="rows.row.asmblAccFlag" @change="commonChangeEvent(rows.row, true)"/>
                    </template>
                </el-table-column>
                <el-table-column align="right" prop="price" label="含税价(元)" width="90">
                    <template slot-scope="rows">
                        <el-input type="number" size="4" :min="0" v-if="!rows.row.validateInfo.price.validateOk" @change="commonChangeEvent(rows.row)" style="background-color: #edd28b; width: 95%;" v-model.number="rows.row.price" :title="rows.row.validateInfo.price.errorMsg"></el-input>
                        <el-input type="number" size="4" :min="0" v-else style="width: 95%;" @change="priceChangeEvent(rows.row)" v-model.number="rows.row.price"></el-input>
                    </template>
                </el-table-column>
                <el-table-column align="right" prop="taxRate" label="税率(%)" width="90"></el-table-column>
                <el-table-column align="right" prop="ntxPrice" label="未税价(元)" width="90">
                    <template slot-scope="rows">
                        <span v-if="rows.row.ntxPrice != null">{{rows.row.ntxPrice}}</span>
                        <span v-else>0.00</span>
                    </template>
                </el-table-column>
                <el-table-column label="配货数量" prop="quantity" width="100">
                    <template slot-scope="rows">
                        <el-input type="number" size="4" :min="0" v-if="!rows.row.validateInfo.quantity.validateOk" @change="commonChangeEvent(rows.row)" style="background-color: #edd28b; width: 95%;" v-model.number="rows.row.quantity" :title="rows.row.validateInfo.quantity.errorMsg"></el-input>
                        <el-input type="number" size="4" :min="0" v-else style="width: 95%;" @change="commonChangeEvent(rows.row)" v-model.number="rows.row.quantity"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="单位" prop="unit">
                    <template slot-scope="rows">
                        <div v-if="!rows.row.validateInfo.unit.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.unit.errorMsg">
                            <span>{{rows.row.unit}}</span>
                        </div>
                        <span v-else>{{rows.row.unit}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="要求到货日期" prop="desireArriveDate" align="center" width="120">
                    <template slot-scope="rows">
                        <div v-if="!rows.row.validateInfo.desireArriveDate.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.desireArriveDate.errorMsg">
                            <el-date-picker v-model="rows.row.desireArriveDate" type="date" placeholder="选择日期" :picker-options="pickerOptions0" format="yyyy-MM-dd"></el-date-picker>
                        </div>
                        <el-date-picker v-else v-model="rows.row.desireArriveDate" type="date" placeholder="选择日期" :picker-options="pickerOptions0" format="yyyy-MM-dd"></el-date-picker>
                    </template>
                </el-table-column>
                <el-table-column label="说明" prop="desc" width="160">
                    <template slot-scope="rows">
                        <input type="text" v-if="!rows.row.validateInfo.desc.validateOk" @change="commonChangeEvent(rows.row)" style="background-color: #edd28b; width: 95%;" v-model="rows.row.desc" :title="rows.row.validateInfo.desc.errorMsg"/>
                        <input type="text" v-else style="width: 95%;" @change="commonChangeEvent(rows.row)" v-model="rows.row.desc"/>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="clearfix">
            <el-pagination background class="fl mt5" v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
            <div class="swb-btn swb-btn-small fr mt10" @click="downloadAllocFormImpModel">导出全部配货信息</div>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="doAllocFormImpModelImport">检查并导入</div>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="validateMerchtAllocFormImpModel(true)">逐条检查</div>
        </div>
    </div>

</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { openPageRouteUrl, getDefaultPageSizes } from '../../../src/app.conf'
    import { showMerchtDevcDefSelectDlg, openDevcDefSaveDlg } from '../devcDef/showDlg'
    import { showAsmblAccDefSelectDlg, openAccDefSaveDlg } from '../asmblAcc/dialog'
    import { getMerchantBizParam } from '../asset/assetMain'

    import goodsOrderApi from '../../api/goodsOrder'
    import retailerApi from '../../api/retailer'
    import devcDefApi from '../../api/devcDef'
    import asmblAccApi from '../../api/asmblAcc'

    export default {
        name: 'swb-alloc-form-imp-check',
        desc: '配货导入检查',
        props: ['fileObj', 'rootWidth', 'rootHeight', 'theDlg'],
        data: function () {
            return {
                tableHeight: 0,
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: [15, 50, 100, 200],// 特殊页面处理
                pageAllocFormImpList: {},
                allocFormImpDto: {
                    originalFileName: null,
                    impInfoList: [],
                    dumyBrandNames: []
                },
                taxRate: null,
                isOk: false,
                theLoading: null,
                multipleSelection: [],
                retailerInfo: null,
                virtualBrandStr: '',
                max_quantity_per_item: 50,
                startFlag: false, // 标记是否已开始逐条执行
                nextIndex: 0,
                checkNextIndex: 0,
                title: null,
                autoSend: false,
                normalFlag: false,
                needAudit: false,
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                }
            }
        },
        watch: {
            rootWidth(newVal, oldVal){
                //
            },
            rootHeight(newVal, oldVal){
                this.recalcTableHeight();
            }
        },
        created: function () {
            this.recalcTableHeight();
            //
            let self = this;
            getMerchantBizParam("asset.finac.enabled", function (normalFlagResult) { // 无效
                self.normalFlag = Utils.isTrue(normalFlagResult);
            });
            getMerchantBizParam("asset.definition.create.alter.need.audit", function (result) {  // 新增/变更资产定义是否需要审核
                self.needAudit = Utils.isTrue(result);
            }, 0);
            //
            let theLoading = MsgBox.loading();
            this.allocFormImpDto.originalFileName = this.fileObj.extra.originalFileName;
            let impInfoList = this.fileObj.extra.impInfoList || [];
            impInfoList.forEach(function (el) {
                el.validateInfo = {
                    buyerShopName: {validateOk: Utils.isFalse(el.buyerShopNameValidateOk) ? false : true},
                    buyerRecvRegionName: {validateOk: Utils.isFalse(el.buyerRecvRegionNameValidateOk) ? false : true},
                    buyerRecvStreet: {validateOk: Utils.isFalse(el.buyerRecvStreetValidateOk) ? false : true},
                    sellerName: {validateOk: Utils.isFalse(el.sellerNameValidateOk) ? false : true},
                    title: {validateOk: Utils.isFalse(el.titleValidateOk) ? false : true},
                    catName: {validateOk: Utils.isFalse(el.catNameValidateOk) ? false : true},
                    brandName: {validateOk: Utils.isFalse(el.brandNameValidateOk) ? false : true},
                    assetDefId: {validateOk: Utils.isFalse(el.assetDefIdValidateOk) ? false : true},
                    buyerRecvContractName: {validateOk: true},
                    buyerRecvContactTel: {validateOk: Utils.isFalse(el.buyerRecvContactTelValidateOk) ? false : true},
                    price: {validateOk: Utils.isFalse(el.priceValidateOk) ? false : true},
                    arriveDays: {validateOk: Utils.isFalse(el.arriveDaysValidateOk) ? false : true},
                    quantity: {validateOk: Utils.isFalse(el.quantityValidateOk) ? false : true},
                    unit: {validateOk: Utils.isFalse(el.unitValidateOk) ? false : true},
                    desireArriveDate: {validateOk: Utils.isFalse(el.desireArriveDateValidateOk) ? false : true},
                    desc: {validateOk: Utils.isFalse(el.descValidateOk) ? false : true}
                };
            });
            this.allocFormImpDto.impInfoList = impInfoList;
            //
            this.pageSize = this.pageSizes.first();
            self.checkData();
            self.setPageAllocFormImpInfoList();
            theLoading.close();
        },
        methods: {
            taxRateChange: function (taxRate) {
                if(!Utils.isNoB(taxRate)) {
                    if(!Utils.isMoneyStr(taxRate)) {
                        taxRate = null;
                        MsgBox.warning("请输入正确的税率！");
                        return;
                    } else {
                        let taxRateF = parseFloat(taxRate);
                        if(taxRateF > 100) {
                            taxRate = null;
                            MsgBox.warning("税率不能超过100！");
                            return;
                        } else {
                            taxRate = taxRateF.toFixed(2);
                        }
                    }
                } else {
                    MsgBox.warning("请输入税率！");
                    return;
                }
                this.taxRate = taxRate;
                let allocFormImpDto = this.allocFormImpDto;
                let itemList = allocFormImpDto.impInfoList || [];
                if(itemList.length > 0) {
                    for(let i = 0; i < itemList.length; i++) {
                        let item = itemList[i];
                        //
                        item.taxRate = taxRate;
                        if(Utils.isNoB(taxRate) || Utils.isNoB(item.price)) {
                            item.ntxPrice = item.price;
                        } else {
                            item.ntxPrice = (parseFloat(item.price) / (1 + (parseFloat(taxRate) * 0.01))).toFixed(2);
                        }
                    }
                }
                allocFormImpDto.impInfoList = Utils.merge([], itemList);
                this.allocFormImpDto = Utils.merge({}, allocFormImpDto);
                this.setPageAllocFormImpInfoList();
            },
            recalcTableHeight(){
                this.tableHeight = this.rootHeight - 60 - 42;
            },
            // 选中行
            markSelectedRowClassName(row){
                return this.multipleSelection.find(function (tmpRow) {
                    return tmpRow.rowNo == row.rowNo;
                }) != null ? 'selected-row' : '';
            },
            // 含税价变化事件
            priceChangeEvent(row){
                // 未税价格
                if(!Utils.isNoB(row.price)) {
                    let taxRate = row.taxRate || 0;
                    row.ntxPrice = (parseFloat(row.price) / (1 + (parseFloat(taxRate) * 0.01))).toFixed(2);
                } else {
                    row.ntxPrice = null;
                }
                this.checkData(row);
            },
            //自动合并数据行
            commonChangeEvent(row, asmblAccFlag){
                if(Utils.isTrue(asmblAccFlag)) {
                    row.assetDefId = null;
                }
                this.checkData(row);
            },
            checkData (rowData) {
                let self = this;
                let rows = this.allocFormImpDto.impInfoList.clone();
                let itemLength = rows.length;
                let byItemFlag = itemLength > 500;
                for(let i = 0; i < rows.length; i++) {
                    let allocFormImpDto = rows[i];
                    // 检查 [机构名称]
                    if(!Utils.isNoB(allocFormImpDto.buyerShopName)) {
                        allocFormImpDto.buyerShopName = this.replaceSL(allocFormImpDto.buyerShopName, ' ');
                    }
                    if(Utils.isNoB(allocFormImpDto.buyerShopName)) {
                        allocFormImpDto.validateInfo.buyerShopName = {
                            validateOk: false,
                            errorMsg: "[机构名称]单元不可为空"
                        };
                    }
                    // 检查 [地址信息]
                    if(!Utils.isNoB(allocFormImpDto.buyerRecvRegionName)) {
                        allocFormImpDto.buyerRecvRegionName = this.replaceSL(allocFormImpDto.buyerRecvRegionName, ' ');
                    }
                    if(Utils.isNoB(allocFormImpDto.buyerRecvRegionName)) {
                        allocFormImpDto.validateInfo.buyerRecvRegionName = {
                            validateOk: false,
                            errorMsg: "[地址信息]单元不可为空"
                        };
                    }
                    // 检查 [详细地址]
                    if(!Utils.isNoB(allocFormImpDto.buyerRecvStreet)) {
                        allocFormImpDto.buyerRecvStreet = this.replaceSL(allocFormImpDto.buyerRecvStreet, ' ');
                    }
                    if(Utils.isNoB(allocFormImpDto.buyerRecvStreet)) {
                        allocFormImpDto.validateInfo.buyerRecvStreet = {
                            validateOk: false,
                            errorMsg: "[详细地址]单元不可为空"
                        };
                    }
                    // 检查 [供应商]
                    if(!Utils.isNoB(allocFormImpDto.sellerName)) {
                        allocFormImpDto.sellerName = this.replaceSL(allocFormImpDto.sellerName, ' ');
                    }
                    if(Utils.isNoB(allocFormImpDto.sellerName)) {
                        allocFormImpDto.validateInfo.sellerName = {
                            validateOk: false,
                            errorMsg: "[供应商]单元不可为空"
                        };
                    }
                    // 检查 [产品名称]
                    if(!Utils.isNoB(allocFormImpDto.title)) {
                        allocFormImpDto.title = this.replaceSL(allocFormImpDto.title, ' ');
                    }
                    if(Utils.isNoB(allocFormImpDto.title)) {
                        allocFormImpDto.validateInfo.title = {
                            validateOk: false,
                            errorMsg: "[产品名称]单元不可为空"
                        };
                    }
                    // 检查 [分类]
                    if(allocFormImpDto.catId == null) {
                        allocFormImpDto.validateInfo.catName = {
                            validateOk: false,
                            errorMsg: "此分类不存在"
                        };
                    }
                    // 检查 [品牌]
                    if(allocFormImpDto.brandId == null) {
                        allocFormImpDto.validateInfo.brandName = {
                            validateOk: false,
                            errorMsg: "此品牌不存在"
                        };
                    }
                    // 检查 [关联定义]
                    if(allocFormImpDto.assetDefId == null) {
                        allocFormImpDto.validateInfo.assetDefId = {
                            validateOk: false,
                            errorMsg: "未关联定义"
                        };
                    }
                    // 价格
                    if(!Utils.isMoneyStr(allocFormImpDto.price, true)) {
                        allocFormImpDto.validateInfo.price = {
                            validateOk: false,
                            errorMsg: "[价格]请输入大于等于0的数字"
                        };
                    }
                    // 税率计算
                    if(Utils.isNoB(allocFormImpDto.taxRate)) {
                        allocFormImpDto.validateInfo.taxRate = {
                            validateOk: false,
                            errorMsg: "[税率]请输入大于等于0的数字"
                        };
                    } else {
                        if(!Utils.isNaturalStr(allocFormImpDto.taxRate, true)) {
                            allocFormImpDto.validateInfo.taxRate = {
                                validateOk: false,
                                errorMsg: "[税率]请输入大于等于0的数字"
                            };
                        }
                    }
                    if(!Utils.isNoB(allocFormImpDto.price) && !Utils.isNoB(allocFormImpDto.taxRate)) {
                        allocFormImpDto.ntxPrice = (allocFormImpDto.price / (1 + (allocFormImpDto.taxRate * 0.01))).toFixed(2);
                    }
                    //
                    // 检查 [配货数量]
                    if(Utils.isNoB(allocFormImpDto.quantity)) {
                        allocFormImpDto.quantity = 1;
                    }
                    if(!Utils.isNaturalStr(allocFormImpDto.quantity, true)) {
                        allocFormImpDto.validateInfo.quantity = {
                            validateOk: false,
                            errorMsg: "[配货数量]单元只能输入正整数"
                        };
                    }
                    // 检验【联系人】
                    if(Utils.isNoB(allocFormImpDto.buyerRecvContractName)) {
                        allocFormImpDto.validateInfo.buyerRecvContractName = {
                            validateOk: false,
                            errorMsg: "[联系人]不能为空！"
                        };
                    }
                    // 检验【联系电话】
                    if(!Utils.isNoB(allocFormImpDto.buyerRecvContactTel)) {
                        if(!Utils.isPhoneNo(allocFormImpDto.buyerRecvContactTel)) {
                            allocFormImpDto.validateInfo.buyerRecvContactTel = {
                                validateOk: false,
                                errorMsg: "[联系电话]格式不正确！"
                            };
                        }
                    } else {
                        allocFormImpDto.validateInfo.buyerRecvContactTel = {
                            validateOk: false,
                            errorMsg: "[联系电话]不能为空！"
                        };
                    }
                    // 检验【要求到货日期】
                    if(Utils.isNoB(allocFormImpDto.desireArriveDate)) {
                        allocFormImpDto.validateInfo.desireArriveDate = {
                            validateOk: false,
                            errorMsg: "[要求到货日期]不能为空！"
                        };
                    }
                    // 检查修正 [说明]
                    if(!Utils.isNoB(allocFormImpDto.desc)) {
                        if(allocFormImpDto.desc.length > 60) {
                            allocFormImpDto.validateInfo.desc = {
                                validateOk: false,
                                errorMsg: "[说明]单元长度最大60，当前[" + allocFormImpDto.desc.length + "]"
                            };
                        }
                    }
                }
                //记录被选中的行
                let oldSelectedRowNos = this.multipleSelection.pluck('rowNo') || [];
                //
                this.allocFormImpDto.impInfoList = rows;
                this.setPageAllocFormImpInfoList();
                //（必须）延迟恢复被选中的行
                setTimeout(function () {
                    self.allocFormImpDto.impInfoList.forEach(function (row) {
                        if(oldSelectedRowNos.indexOf(row.rowNo) != -1) {
                            self.$refs.allocFormImpTable.toggleRowSelection(row);
                        }
                    });
                }, 1000);
            },
            setPageAllocFormImpInfoList: function () {
                let totalRows = this.allocFormImpDto.impInfoList;
                this.totalCount = totalRows.length;
                let start = (this.pageNumber - 1) * this.pageSize;
                let end = this.pageNumber * this.pageSize;
                let rows = totalRows.slice(start, end);
                this.pageAllocFormImpList = rows;
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.setPageAllocFormImpInfoList();
            },
            // 导出全部配货信息
            downloadAllocFormImpModel: function () {
                let allocFormImpDto = this.allocFormImpDto || {};
                let impInfoList = allocFormImpDto.impInfoList || [];
                if(impInfoList.length > 0) {
                    for(let i = 0; i < impInfoList.length; i++) {
                        let itemInfo = impInfoList[i];
                        if(!Utils.isNoB(itemInfo.desireArriveDate)) {
                            itemInfo.desireArriveDate = new Date(itemInfo.desireArriveDate).format('yyyy-MM-dd');
                        }
                    }
                }
                let theLoad = MsgBox.loading();
                goodsOrderApi.allocFormImpModelForExport(this.allocFormImpDto, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        Utils.downloadFile(getAppUrl(result.data));
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let self = this;
                // 虚拟品牌校验
                let virtualBrandStr = this.virtualBrandStr;
                let virtualBrand = [];
                if(!Utils.isNoB(virtualBrandStr)) {
                    virtualBrand = virtualBrandStr.split('|');
                }
                this.allocFormImpDto.dumyBrandNames = virtualBrand;
                return this.allocFormImpDto;
            },
            // 选择行
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 逐条检查
            validateMerchtAllocFormImpModel: function (isFirst) {
                this.checkNextIndex = isFirst ? 0 : this.checkNextIndex;
                this.startFlag = true;
                let self = this;
                this.getDlgResult();
                let allocFormImpDto = this.allocFormImpDto;
                //
                let srcAllocFormImpInfoList = allocFormImpDto.impInfoList || [];
                let srcListLength = srcAllocFormImpInfoList.length;
                //
                let checkNextIndex = this.checkNextIndex;
                let srcImpInfo = srcAllocFormImpInfoList[checkNextIndex];
                if(srcImpInfo.desireArriveDate != null) {
                    srcImpInfo.desireArriveDate = new Date(srcImpInfo.desireArriveDate).format("yyyy-MM-dd");
                }
                let postData = Utils.merge({}, allocFormImpDto);
                postData.impInfoList = [srcImpInfo];

                let theLoading = MsgBox.loading("【源件行号：" + srcImpInfo.rowNo + "】正在处理，请稍后...");
                goodsOrderApi.validateOrderGoodsAllocFormImpTemplate(postData, function (result) {
                    theLoading.hide();
                    let callItem = result.data.impInfoList[0];
                    if(result.type == 'info') {
                        callItem.failed = false;
                        callItem.failDesc = null;
                    } else {
                        callItem.failed = true;
                        callItem.failDesc = result.message;
                    }
                    srcAllocFormImpInfoList[checkNextIndex] = Utils.merge({}, callItem);
                    allocFormImpDto.srcAllocFormImpInfoList = srcAllocFormImpInfoList;
                    self.allocFormImpDto = Utils.merge({}, allocFormImpDto);
                    self.checkData();
                    //
                    let pageSize = self.pageSize;
                    let pageNumber = (checkNextIndex + 1) / pageSize;
                    let pageNumber2 = (checkNextIndex + 1) % pageSize;
                    if(pageNumber2 != 0) {
                        pageNumber = pageNumber + 1;
                    }
                    self.handlePageChange(pageNumber);
                    //
                    if(checkNextIndex < srcListLength - 1) {
                        self.checkNextIndex += 1;
                        self.validateMerchtAllocFormImpModel(false);
                    } else {
                        self.handlePageChange(1);
                    }
                });
            },
            // 检查并导入
            doAllocFormImpModelImport(){
                let self = this;
                this.getDlgResult();
                let allocFormImpDto = this.allocFormImpDto;
                // 判断全部的状态是否是ok
                let srcAllocFormImpInfoList = allocFormImpDto.impInfoList || [];
                let srcListLength = srcAllocFormImpInfoList.length;
                if(srcListLength > 500) {
                    //弹出确认框
                    this.$confirm('数据较多,将会执行一段时间,请勿关闭此页面或关闭浏览器,确定导入吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        self.doAllocFormImpModelImportStart();
                    }).catch(function () {

                    });
                } else {
                    if(srcListLength == 0) {
                        Toast.show("没有要导入的配货数据!");
                        return false;
                    }
                    self.doAllocFormImpModelImportStart();
                }
            },
            // 开始导入
            doAllocFormImpModelImportStart(){
                let self = this;
                if(Utils.isNoB(this.title)) {
                    Toast.show("请输入配货标题！");
                    return false;
                }
                if(Utils.isNoB(this.taxRate)) {
                    Toast.show("请输入税率！");
                    return false;
                }
                this.startFlag = true;
                let autoSend = this.autoSend;
                let confirmMsg = '';
                if(Utils.isTrue(autoSend)) {
                    confirmMsg = '批量配货后会自动发送!';
                } else {
                    confirmMsg = '开始批量配货!';
                }
                self.$confirm(confirmMsg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    //
                    let currDate = new Date().format('yyyy-MM-dd');
                    let srcDeviceImpDto = self.allocFormImpDto;
                    let impInfoList = srcDeviceImpDto.impInfoList || [];
                    for(let i = 0; i < impInfoList.length; i++) {
                        let impInfo = impInfoList[i];
                        let desireArriveDate = impInfo.desireArriveDate;
                        if(Utils.isNoB(desireArriveDate)) {
                            Toast.show("【源件行号：" + impInfo.rowNo + "】请输入要求到货日期！");
                            return false;
                        }
                        desireArriveDate = new Date(desireArriveDate).format('yyyy-MM-dd');
                        if(desireArriveDate < currDate) {
                            Toast.show("【源件行号：" + impInfo.rowNo + "】要求到货日期不能小于今天！");
                            return false;
                        }
                        if(Utils.isNoB(impInfo.assetDefId)) {
                            Toast.show("【源件行号：" + impInfo.rowNo + "】请关联定义！");
                            return false;
                        }
                        impInfo.desireArriveDate = desireArriveDate;
                    }
                    srcDeviceImpDto.autoSend = autoSend;
                    srcDeviceImpDto.title = self.title;
                    srcDeviceImpDto.impInfoList = impInfoList;
                    self.startDone(srcDeviceImpDto);
                }).catch(function () {
                });
            },
            startDone(impDto){
                let self = this;
                let theLoading = MsgBox.loading("正在处理，请稍后...");
                goodsOrderApi.doImportOrderGoodsAllocForms(impDto, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        //
                        let params = {
                            success: true,
                            message: "批量配货完毕！"
                        };
                        self.$emit('other-close', params);
                    } else {
                        let params = {
                            success: false,
                            message: result.message
                        };
                        self.$emit('other-close', params);
                    }
                });
            },
            replaceSL(str, char){
                if(!Utils.isNoB(str)) {
                    str = Utils.replace(str, '\r\n', char);
                    str = Utils.replace(str, '\r', char);
                    str = Utils.replace(str, '\n', char);
                }
                return str;
            },
            setDevcDef(row) {
                let self = this;
                if(row.asmblAccFlag) {
                    showAsmblAccDefSelectDlg({
                        filter: {},
                        checkBox: false
                    }, function (devcDef, dlg) {
                        dlg.close();
                        row.assetDefId = devcDef.id;
                        row.devcName = devcDef.title;
                        self.allocFormImpDto.impInfoList = Utils.merge({}, self.allocFormImpDto.impInfoList);
                        self.setPageAllocFormImpInfoList();
                    });
                } else {
                    showMerchtDevcDefSelectDlg({
                        catId: row.catId,
                        brandId: row.brandId,
                        modelSpec: row.shortSpec,
                        assetType: 0,
                        normalized: Utils.isTrue(self.normalFlag) ? true : null
                    }, function (devcDef, dlg) {
                        dlg.close();
                        row.assetDefId = devcDef.id;
                        row.devcName = devcDef.title;
                        self.allocFormImpDto.impInfoList = Utils.merge({}, self.allocFormImpDto.impInfoList);
                        self.setPageAllocFormImpInfoList();
                    });
                }
            },
            delDevcDef(row) {
                let self = this;
                if(row.assetDefId != null) {
                    row.assetDefId = null;
                    row.devcName = null;
                    self.allocFormImpDto.impInfoList = Utils.merge({}, self.allocFormImpDto.impInfoList);
                    self.setPageAllocFormImpInfoList();
                }
            },
            saveDevcDef(row){
                let self = this;
                let devcDef = row;
                devcDef.name = row.title;
                devcDef.model = row.model;
                devcDef.fixedSpec = row.fixedSpec;
                let title = row.title;
                if(!Utils.isNoB(row.model)) {
                    title = title + row.model;
                }
                if(!Utils.isNoB(row.fixedSpec)) {
                    title = title + row.fixedSpec;
                }
                devcDef.title = title;
                devcDef.theUnit = row.unit;
                devcDef.createDef = true;

                let allocFormImpDto = this.allocFormImpDto;
                let itemList = allocFormImpDto.impInfoList || [];
                if(row.asmblAccFlag) {
                    devcDef.centBuyMode = false;
                    openAccDefSaveDlg({
                        row: devcDef,
                        buildFlag: true
                    }, function (result, theDlg) {
                        theDlg.close();
                        let postData = result;
                        postData.assetType = 3;
                        postData.createFlag = true;
                        let msgBoxDlg = MsgBox.loading();
                        asmblAccApi.getAsmblAccDefByUK(postData, function (result) {
                            msgBoxDlg.close();
                            if(result.type == 'info') {
                                let accDef = result.data;
                                row.assetDefId = accDef.id;
                                row.devcName = devcDef.title;
                                self.allocFormImpDto.impInfoList = Utils.merge({}, itemList);
                                self.setPageAllocFormImpInfoList();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    });
                } else {
                    devcDef.centBuyRequired = false;
                    devcDef.vendorUknoFlag = false;
                    devcDef.setupFlag = false;
                    devcDef.asmblFlag = false;
                    devcDef.asmblWhileSetup = false;
                    devcDef.stockFifo = false;
                    devcDef.purchFlag = true;
                    devcDef.assetType = 0;
                    let params = {
                        row: devcDef,
                        normalized: Utils.isTrue(self.normalFlag),
                        assetTypeDisabled: true,
                        purchFlagDisabled: true
                    };
                    openDevcDefSaveDlg(params, function (result, theDlg) {
                        theDlg.close();
                        let postData = result;
                        postData.normalized = Utils.isTrue(self.normalFlag);
                        postData.createFlag = true;
                        let msgBoxDlg = MsgBox.loading();
                        devcDefApi.getMerchtDevcDefInfoByUK(postData, function (result) {
                            msgBoxDlg.close();
                            if(result.type == 'info') {
                                let devcDef = result.data;
                                row.assetDefId = devcDef.id;
                                row.devcName = devcDef.title;
                                self.allocFormImpDto.impInfoList = Utils.merge({}, itemList);
                                self.setPageAllocFormImpInfoList();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    });
                }
            }
        }
    }
</script>

<style>
    .el-table .selected-row {
        background: #c9e5f5;
    }
</style>



// WEBPACK FOOTER //
// src/compo/order/AllocFormImpCheck.vue